/**
 * Shipping Bar
 * Hacky logic to make the 3rd party shipping bar logic work.
 * @class
 */
class ShippingBar {
  shippingBarElement: HTMLElement;
  resizeTimeout: NodeJS.Timeout;
  pollTimer: NodeJS.Timer;
  isAttached = false;

  constructor() {
    this.resetShippingBarHeight();
    this.pollForShippingBar();
  }

  /**
   * Check on an interval for the shipping bar to load.
   */
  pollForShippingBar() {
    let pollCounter = 0;
    this.pollTimer = setInterval(() => {
      const shippingBarElement: HTMLElement =
        document.querySelector('#cb-shipping-bar');
      // @ts-ignore
      if (shippingBarElement && window.conversionBearFreeShippingBar) {
        this.shippingBarElement = shippingBarElement;
        this.attachEvents();

        // Wait for shipping bar to enter the view.
        setTimeout(() => {
          this.setShippingBarHeight();
        }, 2500);

        clearInterval(this.pollTimer);
      } else if (pollCounter === 50) {
        clearInterval(this.pollTimer);
      }
      pollCounter++;
    }, 10);
  }

  /**
   * Attaches Relevant Dom Events.
   */
  attachEvents(): void {
    // @ts-ignore
    window.conversionBearFreeShippingBar.setCustomOnShowFunction(() => {
      if (!this.isAttached) {
        this.isAttached = true;
        window.addEventListener('resize', this.handleResize);
      }
    });

    // @ts-ignore
    window.conversionBearFreeShippingBar.setCustomOnCloseFunction(() => {
      setTimeout(() => {
        this.isAttached = false;
        window.removeEventListener('resize', this.handleResize);
        this.resetShippingBarHeight();
      });
    });
  }

  handleResize = () => {
    clearTimeout(this.resizeTimeout);
    // Set small delay to fix chrome rotation on IOS firing resize too early
    this.resizeTimeout = setTimeout(() => {
      this.setShippingBarHeight();
    }, 50);
  };

  /**
   * Sets a css4 variable for the shipping bar height on the window.
   */
  setShippingBarHeight(): void {
    const height = this.shippingBarElement.clientHeight;
    document.documentElement.style.setProperty(
      '--shipping-bar-height',
      `${height}px`
    );
    document.body.setAttribute('data-shipping-bar', 'true');
  }

  /**
   * Resets the shipping bar height to 0.
   */
  resetShippingBarHeight(): void {
    document.documentElement.style.setProperty(
      '--shipping-bar-height',
      `${0}px`
    );
    document.body.removeAttribute('data-shipping-bar');
  }
}

/**
 * Initiate the shipping bar plugin (Hack for height issue);
 */
export const shippingBarInit = () => {
  //@ts-ignore
  window.shippingBarHelper = new ShippingBar();
};
